/* eslint comma-dangle: "off" */
export const routeConfig = {
  settings: {
    information: {
      enabled: true,
      visible: true,
      path: "information",
      title: "hotel_information",
      component: "Information",
    },
    accommodations: {
      enabled: true,
      visible: true,
      path: "accommodations",
      title: "hotel_accommodations",
      component: "Accommodations",
    },
    rateManagement: {
      enabled: true,
      visible: true,
      path: "ratemanagement",
      title: "Rate Management",
      component: "RateManagement",
    },
    bookingPackages: {
      enabled: false,
      visible: false,
      path: "bookingpackages",
      title: "Booking Packages",
      component: "BookingPackages",
    },
    inventory: {
      enabled: true,
      visible: true,
      path: "inventory",
      title: "settings.pos.inventory.title",
      component: "Inventory",
      requiresPOS: true,
    },
    menuCategories: {
      enabled: true,
      visible: true,
      path: "menucategories",
      title: "settings.pos.menu_categories.title",
      component: "MenuCategories",
      requiresPOS: true,
    },
    discountCodes: {
      enabled: false,
      visible: false,
      path: "discount-codes",
      title: "Discount Codes",
      component: "DiscountCodes",
    },
    taxes: {
      enabled: true,
      visible: true,
      path: "taxes",
      title: "settings.tax.title",
      component: "TaxesAndFees",
    },
    tagManagement: {
      enabled: true,
      visible: true,
      path: "tags",
      title: "Tag Management",
      component: "TagManagement",
    },
    payments: {
      enabled: false,
      visible: false,
      path: "integrations",
      title: "settings.payments.title",
      component: "Integrations",
    },
    employees: {
      enabled: false,
      visible: false,
      path: "employees",
      title: "Employees",
      component: "Employees",
    },
    general: {
      enabled: false,
      visible: false,
      path: "general",
      title: "Emails",
      component: "General",
    },
    channelManager: {
      enabled: false,
      visible: false,
      path: "channel-manager",
      title: "Channel Manager",
      component: "ChannelManager",
    },
    help: {
      enabled: false,
      visible: false,
      path: "help",
      title: "Help",
      component: "Help",
    },
    account: {
      enabled: false,
      visible: false,
      path: "account",
      title: "Account",
      component: "Account",
    },
    billing: {
      enabled: true,
      visible: false,
      path: "billing",
      title: "Billing",
      component: "Billing",
    },
  },
};
